import * as ACTIONS from '../../actionTypes/priceMatrixActionTypes';

const initialState = {};

function labels(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.LABELS_INIT_SUCCESS:
      return {
        priceMatrix: action.labels,
        alternativeHotels: action.alternativeHotelsLabels,
      };
    default:
      return state;
  }
}

export default labels;
